<div class="max-h-[90vh]" data-testid="esg-gerl-update-modal">
  <h3 nxHeadline class="nx-font-weight-semibold" size="m">
    @if (data.controllerI18n | translate; as controlName) {
      {{ 'update.modal.title' | translate: { controlName } }}
    }
  </h3>
  <div class="mt-3">
    <span class="nx-font-weight-semibold">{{ 'update.modal.date' | translate }}</span> {{ todaysDate }}
  </div>
  <form class="mt-3" [formGroup]="updateForm">
    <nx-radio-group name="checkResponse" formControlName="checkResponse">
      <nx-label size="small" class="nx-margin-bottom-s nx-font-weight-semibold">{{
        'update.modal.issue' | translate
      }}</nx-label>
      <nx-radio labelSize="small" value="reject" class="nx-margin-bottom-m">{{
        'update.modal.yes-escalate' | translate
      }}</nx-radio>
      <nx-radio labelSize="small" value="accept">{{ 'update.modal.no' | translate }}</nx-radio>
    </nx-radio-group>
    @if (updateForm.value.checkResponse === 'reject') {
      <nx-formfield [label]="'update.modal.esg-gerl.quiz-comment' | translate" class="mt-3.5 -mb-3">
        <textarea nxInput rows="12" spellcheck="false" formControlName="esgGerlQuizComment" type="text"></textarea>
      </nx-formfield>
    }
  </form>
  <nx-formfield class="mt-3" [label]="'escalate.modal.comment-optional' | translate">
    <textarea rows="5" spellcheck="false" nxInput [(ngModel)]="comment" type="text"></textarea>
  </nx-formfield>
  <kyc-file-uploader
    [showOptional]="true"
    (filesChange)="onFilesChange($event)"
    (fileDeletion)="onFileDeletion($event)"
  />
  @if (updateForm.value.checkResponse === 'reject' && data.notifications.length) {
    <kyc-notifications-group [notifications]="data.notifications" />
  }
  <div class="flex justify-center mt-7">
    <button (click)="submit()" [disabled]="updateForm.invalid || loading" nxButton="small-medium" type="button">
      @if (loading) {
        <nx-spinner />
      } @else {
        {{ 'update.modal.button.submit' | translate }}
      }
    </button>
  </div>
  <div class="flex justify-center mt-3.5">
    <button (click)="data.closeModal()" [disabled]="loading" nxButton="tertiary small-medium" type="button">
      {{ 'update.modal.button.dismiss' | translate }}
    </button>
  </div>
</div>
